import { createFeature, createReducer, on } from '@ngrx/store';

import { AdministratorCompanyReadOnlySchema, SettingReadOnlySchema } from '@digitalforest/ngx-oak-api';
import { CompanyReadOnlySchema } from '@digitalforest/ngx-oak-api/lib/model/companyReadOnlySchema';

import { ScopeActions } from './scope.actions';

export interface ScopeState {
  company: CompanyReadOnlySchema | null;
  setting: SettingReadOnlySchema | null;
  administratorCompany: AdministratorCompanyReadOnlySchema | null;
}

export const initialState: ScopeState = {
  company: null,
  setting: null,
  administratorCompany: null,
};

export const scopeFeature = createFeature({
  name: 'scope',
  reducer: createReducer(
    initialState,
    on(ScopeActions.loadCompanySuccess, (state, { company, setting, administratorCompany }) => ({
      ...state,
      company,
      setting,
      administratorCompany,
    })),
    on(ScopeActions.unloadCompany, (state) => ({ ...state, company: null, administratorCompany: null })),
  ),
});
